export enum PaymentMethodSelectorField {
  paymentMethod = 'paymentMethod',
  toGoTicketNumber = 'toGoTicketNumber',
  travelCardNumber = 'travelCardNumber',
  otherTicketType = 'otherTicketType',
}
